<template>
  <button class="btn" :class="props.isActive ? 'btn--active' : ''">
    <BellIcon v-if="!props.isActive" :style="{ width: '14px', height: '17px' }"/>
    <BellFullBgIcon v-else :style="{ width: '14px', height: '17px' }"/>
  </button>
</template>

<script setup>
  import BellIcon from '@/Groups/Notifications/private/svg/BellIcon.vue';
  import BellFullBgIcon from '@/Groups/Notifications/private/svg/BellFullBgIcon.vue';
  //------------------------
  const props = defineProps({
    //Активна ли кнопка?
    isActive: { type: Boolean }
  });
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>